import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import { selectIsPrepareDisclosuresWizardOpen } from 'store/loanApplications/selectors';

import PrepareDisclosuresWizardDrawer from './components/PrepareDisclosuresWizardDrawer';
import PrepareDisclosuresWizardProvider from './PrepareDisclosuresWizardProvider';

const PrepareDisclosuresWizard = () => {
  const isOpen = useSelector(selectIsPrepareDisclosuresWizardOpen);

  return (
    <PrepareDisclosuresWizardProvider isOpen={isOpen}>
      <PrepareDisclosuresWizardDrawer />
    </PrepareDisclosuresWizardProvider>
  );
};

export default memo(PrepareDisclosuresWizard);
